module.exports = __webpack_public_path__ + "img/thumbnail-3.496d7d04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-3.jpg
// module id = 6eA4
// module chunks = 1